import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section is-large my-3" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { "data-testid": "result-title-text" }
const _hoisted_4 = { class: "row mt-3 quick-overview" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 mb-2" }, "   ")
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "col-xs-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pull-right" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "responsive-table" }
const _hoisted_9 = { class: "table compare-purchase" }
const _hoisted_10 = {
  class: "border-top-0",
  colspan: "2"
}
const _hoisted_11 = { class: "field text-end" }
const _hoisted_12 = { class: "field text-end" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "field text-end" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "field text-end" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "field text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("message.resultTableHeadline")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("message.costOverview")), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.selfemployedTotalsTotalLeasingRates')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$store.state.formValues.leasingTime || 36) + " " + _toDisplayString(_ctx.$t('message.month')) + ")", 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.monthlyLeasingRate)), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.selfemployedTotalsTotalCostOfInsurance')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$store.state.formValues.leasingTime || 36) + " " + _toDisplayString(_ctx.$t('message.month')) + ")", 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.insuranceComfort)), 1 /* TEXT */)
              ]),
              (_ctx.resultData.monthlyCosts.insuranceWearAndTear > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.selfemployedCostOfInsurancePremiumPlus')) + " ", 1 /* TEXT */),
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$store.state.formValues.leasingTime || 36) + " " + _toDisplayString(_ctx.$t('message.month')) + ")", 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.insuranceWearAndTear)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.resultData.monthlyCosts.inspection > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.selfemployedCostOfInsuranceInspection')) + " ", 1 /* TEXT */),
                      _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$store.state.formValues.leasingTime || 36) + " " + _toDisplayString(_ctx.$t('message.month')) + ")", 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.inspection)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("tr", _hoisted_17, [
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.selfemployedTotalsTotalCostOfLeasing')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$store.state.formValues.leasingTime || 36) + " " + _toDisplayString(_ctx.$t('message.month')) + ")", 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.leasingTotalMonthly)), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}